import { render, staticRenderFns } from "./PlanejamentoAcaoFormApuracao.vue?vue&type=template&id=121600f0"
import script from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoFormApuracao.vue?vue&type=style&index=0&id=121600f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports